import { render, staticRenderFns } from "./ConfirmPrivacyDialog.vue?vue&type=template&id=790f0ec8&scoped=true"
import script from "./ConfirmPrivacyDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmPrivacyDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmPrivacyDialog.vue?vue&type=style&index=0&id=790f0ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790f0ec8",
  null
  
)

export default component.exports